import config from '../config'

class FacebookService {
  initialize() {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: config.FACEBOOK_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v2.11'
      })
    }; // semi-colon very important!

    (function (d, s, id) {
      let js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      js = d.createElement(s); js.id = id
      js.src = '//connect.facebook.net/en_US/sdk.js'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  }
}

const facebookService = new FacebookService()

export default facebookService



// WEBPACK FOOTER //
// ./src/app/infrastructure/FacebookService.js